// src/views/Login.jsx
import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

export default function Login() {
  const { loginWithRedirect, isLoading } = useAuth0();

  useEffect(() => {
    // En cuanto este componente se monte, redirige al Universal Login de Auth0
    loginWithRedirect();
  }, [loginWithRedirect]);

  // Mientras Auth0 prepara la redirección, podemos mostrar null o un loader mínimo
  return isLoading ? null : null;
}
